import _ from "lodash";

function convertMasterRewardToLevelRewardModel(data, levelId) {
  let levelReward = {
    RewardId: data.id,
    RewardCode: data.code,
    Description: data.description,
    LevelId: levelId
  };
  return levelReward;
}

function convertListMasterRewardToLevelRewardModel(data, levelId) {
  let listReward = [];
  _.forEach(data, function(item) {
    listReward.push(convertMasterRewardToLevelRewardModel(item, levelId));
  });
  return listReward;
}

function convertRewardRawModel(data) {
  let reward = {
    id: data.Id,
    code: data.RewardCode,
    description: data.Description
  };
  return reward;
}

function convertLevelRewardRawModel(data, levelId) {
  let levelReward = {
    code: data.RewardCode,
    description: data.Description,
    programLevelId: levelId,
    rewardId: data.RewardId,
    rewardAmount: Number(data.Amount) || 0,
    rewardType: data.RewardType
  };
  if (data.Id) {
    levelReward.id = data.Id;
  }
  return levelReward;
}

function convertListLevelRewardRawModel(data, levelId) {
  let listReward = [];
  _.forEach(data, function(item) {
    listReward.push(convertLevelRewardRawModel(item, levelId));
  });
  return listReward;
}

function convertListRewardRawModel(data) {
  let listReward = [];
  _.forEach(data, function(item) {
    listReward.push(convertRewardRawModel(item));
  });
  return listReward;
}

export default {
  convertRewardRawModel,
  convertListRewardRawModel,
  convertMasterRewardToLevelRewardModel,
  convertListMasterRewardToLevelRewardModel,
  convertListLevelRewardRawModel,
  convertLevelRewardRawModel
};



// WEBPACK FOOTER //
// ./src/store/modules/basic_rewards/transform.js